import React from "react";
import {QuickReplyInput} from "./QuickReplyInput";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const QuickReplyEditor = ({ items, title, onChangeTitle, onChangeItems })=> {
  const add = () => onChangeItems([...(items||[]), { label: "", action: { type: "message", text: "" } }]);
  const update = (i, v) => onChangeItems(items.map((it, idx)=> idx===i? v: it));
  const remove = (i) => onChangeItems(items.filter((_, idx)=> idx!==i));

  return (
    <div>
      <div className="bg-gray-200 p-2 w-[320px]">
        <input
          className="rounded p-1 w-full bg-gray-200"
          value={title}
          onChange={e => onChangeTitle(e.target.value)}
          placeholder="選單標題"
        />
      </div>

      {items?.length > 0 && (
        <div className="p-2">
          {(items || []).map((it, i) => (
            <QuickReplyInput
              key={`quickReplyInput${i}`}
              item={it}
              onChangeOption={e => update(i, {...it, label: e.target.value})}
              onChangeText={e =>
                update(i, {...it, action: {...it.action, text: e.target.value}})
              }
              onRemoveItem={() => remove(i)}
            />
          ))}
        </div>
      )}

      {items.length < 4 &&
        <div className="flex py-2 justify-center items-center">
          <ActionButton iconName="fa-add" variant="outline" onClick={add} />
        </div>
      }
    </div>
  );
}
